export const CHAR_PANEL_TYPE = {
  TOPLEFT: 'topLeft',
  TOPRIGHT: 'topRight',
  BOTTOMLEFT: 'bottomLeft',
  BOTTOMRIGHT: 'bottomRight',
} as const;

export type CHAR_PANEL_TYPE_KEY = keyof typeof CHAR_PANEL_TYPE;
export type CHAR_PANEL_TYPE_VALUE = typeof CHAR_PANEL_TYPE[CHAR_PANEL_TYPE_KEY];

export const CHAR_PANEL_TYPE_MAP = {
  [CHAR_PANEL_TYPE.TOPLEFT]: '왼쪽 위',
  [CHAR_PANEL_TYPE.BOTTOMLEFT]: '왼쪽 아래',
  [CHAR_PANEL_TYPE.TOPRIGHT]: '오른쪽 위',
  [CHAR_PANEL_TYPE.BOTTOMRIGHT]: '오른쪽 아래',
};

export const charPanelList = Object.keys(CHAR_PANEL_TYPE_MAP).map((key) => {
  return {
    key: key,
    value: CHAR_PANEL_TYPE_MAP[key],
  };
});
